require("../src/javascripts/fontawesome/solid.min");
require("../src/javascripts/fontawesome/regular.min");
require("../src/javascripts/fontawesome/duotone.min");
require("../src/javascripts/fontawesome/fontawesome.min");
